import React, { useState } from "react";
import axios from "axios";
import QR from "../qr.png";
import "./QrPaymentModal.css";

interface QrPaymentModalProps {
  commandeId: string;
  onClose: () => void; // called after "Compris, merci !" — caller decides redirect
  onBack: () => void;  // called when user clicks back arrow
}

export default function QrPaymentModal({ commandeId, onClose, onBack }: QrPaymentModalProps) {
  const [submitting, setSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleTerminer = async () => {
    setSubmitting(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_PHP_APP_URL}/commande/update`,
        { IdCommande: commandeId, MethodPayment: "Par rib" },
        { headers: { "Content-Type": "application/json" } }
      );
      setShowSuccess(true);
    } catch {
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {/* ── Overlay ── */}
      <div className="qpm-overlay">
        <div className="qpm-modal">
          {/* Header */}
          <div className="qpm-modal-header">
            <button className="qpm-back-btn" onClick={onBack} title="Retour">
              <i className="bi bi-arrow-left" />
            </button>
            <div>
              <h2 className="qpm-title">Paiement par QR Code</h2>
              <p className="qpm-sub">Sélectionnez votre méthode de paiement</p>
            </div>
            <div style={{ width: 36 }} />
          </div>

          {/* Body */}
          <div className="qpm-body">
            {/* Payment option box */}
            <div className="qpm-option active">
              <div className="qpm-option-header">
                <div className="qpm-opt-icon">
                  <i className="bi bi-bank" />
                </div>
                <div>
                  <h3 className="qpm-opt-title">Virement Bancaire</h3>
                  <span className="qpm-opt-sub">Paiement par RIB avec QR code</span>
                </div>
                <input type="radio" checked readOnly style={{ accentColor: "#2f7bff" }} />
              </div>

              {/* QR content */}
              <div className="qpm-opt-body">
                <div className="qpm-bank-left">
                  <div className="qpm-qr-wrap">
                    <img src={QR} alt="QR Code paiement" />
                  </div>
                  <p style={{ fontFamily: "Lato, sans-serif", marginTop: 8 }}>
                    Scannez pour payer via Banque
                  </p>
                  <p className="qpm-rib-mask">RIB: **** **** **65 77</p>
                </div>

                <div className="qpm-bank-right">
                  <p><b>Banque:</b> Banque Populaire</p>
                  <p><b>RIB:</b> 007 780 0003102000302865 77</p>
                </div>
              </div>
            </div>

            <p className="qpm-secure">🔒 Tous les paiements sont sécurisés et cryptés</p>

            <button
              className="qpm-btn-terminer"
              onClick={handleTerminer}
              disabled={submitting}
            >
              {submitting ? (
                <><span className="qpm-spinner" /> Traitement...</>
              ) : (
                <>Terminer <i className="bi bi-check-circle-fill" /></>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* ── Success popup ── */}
      {showSuccess && (
        <div className="qpm-success-overlay">
          <div className="qpm-success-card">
            <div className="qpm-success-header">
              <div className="qpm-check-circle">✓</div>
            </div>
            <div className="qpm-success-body">
              <h2>Merci pour votre paiement !</h2>
              <p>Veuillez envoyer le reçu à l'adresse ci-dessous</p>
              <div className="qpm-info-box">
                <div className="qpm-info-row">
                  <div className="qpm-info-icon">✉</div>
                  <div className="qpm-info-text">
                    <span className="qpm-info-label">EMAIL</span>
                    <span className="qpm-info-value">wyncontact.ma@gmail.com</span>
                  </div>
                </div>
              </div>
              <button className="qpm-confirm-btn" onClick={onClose}>
                Compris, merci !
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
